import './EventPopup.css';
import React from 'react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import IconClosePrimary from '../../components/atoms/Icons/IconClosePrimary';
const EventPopup = _ref => {
  let {
    heading,
    copy,
    ctaLabel,
    ctaLink
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const [close, setClose] = React.useState(false);
  const processClick = () => {
    setClose(true);
  };

  /* React.useEffect(() => {
  }, []); */

  if (close) return null;
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "events-popup"
  }, /*#__PURE__*/React.createElement("span", {
    className: "events-popup__close",
    onClick: processClick
  }, /*#__PURE__*/React.createElement(IconClosePrimary, null)), /*#__PURE__*/React.createElement("h2", {
    className: "events-popup__title"
  }, heading), /*#__PURE__*/React.createElement("p", {
    className: "body-medium events-popup__copy"
  }, copy), /*#__PURE__*/React.createElement("a", {
    className: "btn btn-primary",
    href: ctaLink,
    onClick: processClick,
    "aria-label": "CTA",
    "aria-labelledby": "CTA"
  }, ctaLabel)));
};
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    className: ` ${rtl ? rtlStyles : ltrStyles} ${commonStyles}`
  }, children);
};
const commonStyles = "clzk9xu";
const ltrStyles = "l3uyxh6";
const rtlStyles = "r7fozbm";
export default EventPopup;